import React from 'react';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

const BreadcrumbComponent = ({ items }) => {
	return (
		<Breadcrumb
			separator="/"
			items={items?.map((item, index) => ({
				title: item.link ? (
					<Link to={item.link}>{item.name}</Link>
				) : (
					item.name
				),
			}))}
		/>
	);
};

export default BreadcrumbComponent;
